import { useMemo } from 'react';

export const useWebsiteId = () => {
  return useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('websiteId') || '';
  }, []);
};